import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  SimpleGrid,
  Card,
  CardBody,
  CardHeader,
  Image,
  Heading,
  Text,
  Spinner,
} from '@chakra-ui/react';
import supabase from '../utils/supabaseUtils';

const EventSignupList = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const { data, error } = await supabase
          .from('events')
          .select('*')
          .eq('status', 'active')
          .order('start_date', { ascending: true });
        if (error) throw error;
        setEvents(data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return (
      <Box py={20} textAlign="center">
        <Spinner />
      </Box>
    );
  }

  return (
    <Box maxW="container.xl" mx="auto" py={10} px={4}>
      <Heading size="lg" mb={8} textAlign="center">Select an Event</Heading>
      {events.length === 0 ? (
        <Text textAlign="center">No active events available.</Text>
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
          {events.map((evt) => (
            <Card
              key={evt.id}
              cursor="pointer"
              onClick={() => navigate(`/signup/${evt.id}`)}
              _hover={{ transform: 'translateY(-4px)', boxShadow: 'lg' }}
            >
              {evt.event_image && (
                <Image src={evt.event_image} alt={evt.name} objectFit="cover" height="160px" />
              )}
              <CardHeader>
                <Heading size="md">{evt.name}</Heading>
              </CardHeader>
              <CardBody>
                <Text noOfLines={2}>{evt.description}</Text>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      )}
    </Box>
  );
};

export default EventSignupList; 